module.exports = __webpack_public_path__ + "static/img/smart.c6849f8c.png";